// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zerJ4IarjfAtPD6_{color:var(--py-neutral-2)}.M0BqLl2cTv8zf0a0{color:var(--py-primary-6)}.Sfcganc3UInIz0ep{height:24px;margin-top:8px}.wu80R7LFXY0qUUa6{display:grid;grid-column-gap:4px;grid-template-columns:20px 1fr;align-items:center}.wu80R7LFXY0qUUa6 .QCzVd0UqeZcKkon6{width:20px;height:20px}.wu80R7LFXY0qUUa6 .aPBdvh3EvYCqhO2y{line-height:20px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.foISsWGSQYI94Axa{display:flex;align-items:center;column-gap:8px}.yN8ydXevDK4LBmB9{display:inline}.yN8ydXevDK4LBmB9 .yLPScpVwqgdWLmHN{display:inline}.yN8ydXevDK4LBmB9 .TrQWr4iLDaYuve_N{display:inline-block;height:10px;width:10px;border-radius:30px;vertical-align:middle;margin-right:4px}.yN8ydXevDK4LBmB9 .ZkDtr6Dpmx8LXZSl{margin-right:4px}.FiKFvYhSMA9BReVS{display:flex;justify-content:space-between;align-items:center}.Nu1NbcoBA8PPRVbK{width:100%}.gBw5igs1XlAmgRSw{height:100%;display:flex;justify-content:end}.gBw5igs1XlAmgRSw .NzidYvHJ6gMjy1fd{display:flex;column-gap:8px;align-items:center;justify-content:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"isPublic": `zerJ4IarjfAtPD6_`,
	"notPublic": `M0BqLl2cTv8zf0a0`,
	"row": `Sfcganc3UInIz0ep`,
	"userBox": `wu80R7LFXY0qUUa6`,
	"userAvatar": `QCzVd0UqeZcKkon6`,
	"userName": `aPBdvh3EvYCqhO2y`,
	"progress": `foISsWGSQYI94Axa`,
	"readableOutlookChip": `yN8ydXevDK4LBmB9`,
	"outlookEntryContainer": `yLPScpVwqgdWLmHN`,
	"outlookColor": `TrQWr4iLDaYuve_N`,
	"outlookName": `ZkDtr6Dpmx8LXZSl`,
	"filterRow": `FiKFvYhSMA9BReVS`,
	"dateRow": `Nu1NbcoBA8PPRVbK`,
	"bulkActionsSwitchContainer": `gBw5igs1XlAmgRSw`,
	"bulkActionsSwitchRow": `NzidYvHJ6gMjy1fd`
};
export default ___CSS_LOADER_EXPORT___;
